module.exports = __webpack_public_path__ + "img/vertical_3_2_8019.a914a21c.png";